/* eslint-disable camelcase */
import React from "react";
import WeerData from "../../images/screenshots/weer_data.png";
import Weer from "../../images/screenshots/weer.png";

const NoRights = ({ image_class, message }) => {
  return (
    <div className="no-rights">
      {image_class === "weather-data" && <img src={WeerData} alt="No rights" />}
      {image_class === "weather" && <img src={Weer} alt="No rights" />}
      <div className="demo-layer">{message}</div>
    </div>
  );
};

export default NoRights;
